module.exports = __webpack_public_path__ + "img/31t.92523a97.jpg";